import React, { useContext, useEffect, useState } from 'react'
import { Form, Button, FormField, Grid, Image } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import styles from './device-view.module.css'
import DeviceActions from './device-actions'
import IntelMsg from '../../../ItelMsg'
import { DeviceViewContext } from './deviceView'
import HC from '../../../../images/HC.png'
import VC from '../../../../images/VC.png'
import SQ from '../../../../images/SQ.png'
import REC from '../../../../images/REC.png'
import HDE from '../../../../images/HDE.png'
import {
  GetAllDeviceInfo,
  SubmitAllDeviceInfo,
  SendCommandDevice,
  SendCommandToDevice,
} from '../../../../services/device-page-list'

// eslint-disable-next-line no-unused-vars
import {
  getHierarchy,
  GetDeviceHierarchy,
  getRegions,
} from '../../../../services/customer'

const DeviceConfigure = () => {
  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))
  const { setViewDevice2, customerId } = useContext(DeviceViewContext)
  const [imei, setIMEI] = useState('')
  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [length, setLength] = useState('')
  const [width, setWidth] = useState('')
  const [height, setHeight] = useState('')
  const [diameter, setDiameter] = useState('')
  const [volume, setVolume] = useState('')
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [simNumber, setSIM] = useState('')
  const [imsi, setIMSI] = useState('')
  const [photo, setPhoto] = useState()
  const [raiser, setRaiser] = useState('')
  const [imgSrc, setImageSource] = useState('')
  const [inactivityTimeout, setInactivityTimeout] = useState(2)

  const [typeOp, setTypeOp] = useState('')
  const [submit, setSubmit] = useState(false)
  const [selectedFile, setSelectedFile] = useState()
  const [edit, setEdit] = useState(false)
  const [zones, setZones] = useState([])
  const [regions, setRegions] = useState([])
  const [sites, setSites] = useState([])
  const [siteId, setSiteId] = useState('')
  const [site, setSite] = useState('')
  const [region, setRegion] = useState('')
  const [country, setCountry] = useState('')

  const types = [
    { key: 1, text: 'Rectangular', value: 'Rectangular' },
    {
      key: 2,
      text: 'Vertical Cylinder',
      value: 'Vertical Cylinder',
    },
    {
      key: 3,
      text: 'Horizontal Cylinder',
      value: 'Horizontal Cylinder',
    },
    { key: 4, text: 'Squared', value: 'Squared' },
  ]

  const getZones = async () => {
    const queryParams = {
      customerId,
      type: 'zone',
      product: 'tank',
    }
    Swal.showLoading()
    const res = await getHierarchy(queryParams)
    if (!res.success) Swal.fire('Error Garbing Level 1', '', 'error')
    else {
      Swal.close()
      setZones(res.data)
    }
  }

  useEffect(() => {
    setSubmit(false)
    GetDeviceHierarchy(deviceData['device id']).then((res) => {
      res.data.map((asset) => {
        if (asset.type === 'zone') {
          setCountry(asset.id)
          handleZoneChange({ target: { value: asset.id, fromState: true } })
        } else if (asset.type === 'region') {
          setRegion(asset.id)
          handleRegionChange({ target: { value: asset.id, fromState: true } })
        } else if (asset.type === 'site') {
          setSite(`${asset.id},${asset.label || asset.name}`)
          setSiteId(asset.id)
        }
        return null
      })
    })
    GetAllDeviceInfo(deviceData['device id']).then((data) => {
      setIMEI(data.imei)
      setName(deviceData['device label'])
      setType(data.type)
      setLength(data.length)
      setWidth(data.width)
      setHeight(data.height)
      setDiameter(data.diameter)
      setVolume(data.volume)
      setLatitude(data.latitude)
      setLongitude(data.longitude)
      setSIM(data.simNumber)
      setIMSI(data.imsi)
      setPhoto(data.imgUrl)
      setRaiser(data.raiser)
      setInactivityTimeout(data.inactivityTimeout / 60 / 24)
      if (data.imei === null || data.imei === '' || data.imei.length < 15)
        setEdit(true)
      else setEdit(false)
    })

    if (type === 'REC') setImageSource(REC)
    if (type === 'VC') setImageSource(VC)
    if (type === 'SQ') setImageSource(SQ)
    if (type === 'HC') setImageSource(HC)
    if (type === 'HDE') setImageSource(HDE)
    getZones()
    setRegions([])
  }, [])

  const formSubmit = () => {
    setSubmit(true)
    SubmitAllDeviceInfo({
      deviceId: deviceData['device id'],
      length,
      type,
      latitude: +latitude,
      imei,
      longitude: +longitude,
      name,
      height,
      imsi,
      picture: photo,
      diameter,
      simNumber,
      width,
      volume: +volume,
      raiser,
      inactivityTimeout: inactivityTimeout * 24 * 60,
      siteId: siteId === '' ? null : siteId.split(',')[0],
      siteName: siteId === '' ? null : siteId.split(',')[1],
    }).then(async (res) => {
      SendCommandToDevice(
        type === 'REC' || type === 'SQ' || type === 'VC' ? height : diameter,
      )
        .then((res2) => {
          if (res2.success) {
            SendCommandDevice(
              deviceData['device name'].slice(4),
              res2.data.message.slice(7),
            )
          }
        })
        .then(() => {
          SendCommandDevice(
            deviceData['device name'].slice(4),
            'R3=ACTIVE',
          ).then(() => {
            SendCommandDevice(deviceData['device name'].slice(4), 'R1=02').then(
              () => {
                if (res === 200) {
                  Swal.fire({
                    title: 'Device Configured Successfully!',
                    icon: 'success',
                    confirmButtonColor: 'Green',
                  })
                  setViewDevice2(false)
                }
              },
            )
          })
        })
    })
  }

  const handleSelect = (e) => {
    setType(e.target.outerText)
    if (e.target.outerText === 'Squared') setType('SQ')
    if (e.target.outerText === 'Rectangular') setType('REC')
    if (e.target.outerText === 'Horizontal Cylinder') setType('HC')
    if (e.target.outerText === 'Vertical Cylinder') setType('VC')
    if (e.target.outerText === 'Horizontal Dish Ends') setType('HDE')
    setLength('')
    setHeight('')
    setDiameter('')
    setWidth('')
  }

  useEffect(() => {
    if (type === 'REC') {
      setImageSource(REC)
      setTypeOp('Rectangular')
    }
    if (type === 'SQ') {
      setImageSource(SQ)
      setTypeOp('Squared')
    }
    if (type === 'HC') {
      setImageSource(HC)
      setTypeOp('Horizontal Cylinder')
    }
    if (type === 'VC') {
      setImageSource(VC)
      setTypeOp('Vertical Cylinder')
    }
    if (type === 'HDE') {
      setImageSource(HDE)
      setTypeOp('Horizontal Dish Ends')
    }
  }, [type])

  useEffect(() => {
    if (type === 'SQ') setWidth(length)
    if (type === 'SQ') setHeight(length)
  }, [type, length])

  useEffect(() => {
    if (type === 'HC')
      setVolume(
        ((22 / 7) * (diameter / 2) * (diameter / 2) * length).toFixed(2),
      )
    if (type === 'SQ') setVolume((length ** 3).toFixed(2))
    if (type === 'REC') setVolume((length * width * height).toFixed(2))
    if (type === 'VC')
      setVolume(
        ((22 / 7) * (diameter / 2) * (diameter / 2) * height).toFixed(2),
      )
  }, [type, length, diameter, width, height])

  useEffect(() => {
    if (submit === false) setEdit(true)
    else setEdit(false)
  }, [imei, submit])

  useEffect(() => {
    if (!selectedFile) {
      setPhoto(undefined)
      return
    }
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        setPhoto(reader.result)
      },
      false,
    )
    if (selectedFile) {
      reader.readAsDataURL(selectedFile)
    }
  }, [selectedFile])

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined)
      return
    }
    setSelectedFile(e.target.files[0])
  }

  const handleZoneChange = async (e) => {
    if (e.target.value === '') {
      setRegions([])
      setSites([])
      setSiteId('')
      return
    }

    if (e.target.fromState === undefined) {
      setSite('')
      setRegion('')
    }
    const zoneId = e.target.value
    setCountry(zoneId)
    const queryParams = {
      product: 'tank',
      customerId,
    }
    Swal.showLoading()
    try {
      const res = await getRegions(queryParams, zoneId)
      if (res.success === false) throw new Error(res)
      Swal.close()
      setRegions(res.data)
    } catch (err) {
      Swal.fire('Error Garbing Level 2 data', '', 'error')
    }
  }

  const handleRegionChange = async (e) => {
    const val = e.target.value
    if (val === '') {
      setSites([])
      setSiteId('')
      return
    }
    const queryParams = {
      customerId,
      levelType: 'site',
      product: 'tank',
    }
    Swal.showLoading()
    const res = await getRegions(queryParams, val)
    setRegion(val)
    if (e.target.fromState === undefined) setSite('')
    if (!res.success) Swal.fire('Error Garbing Level 3', '', 'error')
    else {
      Swal.close()
      setSites(res.data)
    }
  }

  const handleSiteChange = (e) => {
    const val = e.target.value
    setSiteId(val)
    setSite(val)
  }

  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="Device Configuration" />
      </div>{' '}
      <br />
      <Form
        name="confi form"
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
        onSubmit={formSubmit}
      >
        <Form.Field>
          <span style={{ color: 'black' }}>IMEI:</span>
          {edit ? (
            <input
              type="text"
              pattern="\d*"
              minLength="15"
              required
              value={imei}
              onChange={(e) => {
                setIMEI(e.target.value)
              }}
              placeholder="..."
            />
          ) : (
            <input
              disabled
              type="text"
              pattern="\d*"
              minLength="15"
              required
              value={imei}
              placeholder="..."
            />
          )}
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>Tank Name:</span>
          <input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>Type:</span>
          <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column>
                <Form.Input
                  value={typeOp}
                  style={{ width: 300, height: 40 }}
                  control={Form.Select}
                  defaultValue="id"
                  options={types}
                  selection
                  onChange={(e) => handleSelect(e)}
                />
                <small style={{ color: 'red' }}>**</small>
              </Grid.Column>
              <Grid.Column>
                <Image src={imgSrc} size="medium" floated="right" />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form.Field>
        {type === 'SQ' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Length(cm):</span>
            <input
              required
              value={length}
              onChange={(e) => setLength(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}
        {type === 'SQ' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Width(cm):</span>
            <input disabled required value={length} placeholder="..." />
          </Form.Field>
        )}

        {type === 'SQ' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Height(cm):</span>
            <input
              disabled
              required
              value={length}
              onChange={() => setHeight(length)}
              placeholder="..."
            />
          </Form.Field>
        )}
        {type === 'SQ' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Volume(cm):</span>
            <input
              value={
                Math.round((length * length * length + Number.EPSILON) * 100) /
                100
              }
              onChange={(e) => setVolume(e.target.value)}
              placeholder="..."
            />
          </Form.Field>
        )}

        {type === 'REC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Length(cm):</span>
            <input
              required
              value={length}
              onChange={(e) => setLength(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}
        {type === 'REC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Width(cm):</span>
            <input
              required
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}

        {type === 'REC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Height(cm):</span>
            <input
              required
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}
        {type === 'REC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Volume(cm):</span>
            <input
              value={
                (Math.round(length * width * height + Number.EPSILON) * 100) /
                100
              }
              onChange={() =>
                setVolume(
                  Math.round(length * width * height + Number.EPSILON) * 100,
                ) / 100
              }
              placeholder="..."
            />
          </Form.Field>
        )}

        {type === 'HC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Length(cm):</span>
            <input
              required
              value={length}
              onChange={(e) => setLength(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}
        {type === 'HC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Diameter(cm):</span>
            <input
              required
              value={diameter}
              onChange={(e) => setDiameter(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}
        {type === 'HC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Volume(cm):</span>
            <input
              value={
                (Math.round(
                  (22 / 7) * (diameter / 2) * (diameter / 2) * length +
                    Number.EPSILON,
                ) *
                  100) /
                100
              }
              onChange={() =>
                setVolume(
                  (Math.round(
                    (22 / 7) * (diameter / 2) * (diameter / 2) * length +
                      Number.EPSILON,
                  ) *
                    100) /
                    100,
                )
              }
              placeholder="..."
            />
          </Form.Field>
        )}

        {type === 'VC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Diameter(cm):</span>
            <input
              required
              value={diameter}
              onChange={(e) => setDiameter(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}

        {type === 'VC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Height(cm):</span>
            <input
              required
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              placeholder="..."
            />
            <small style={{ color: 'red' }}>**</small>
          </Form.Field>
        )}
        {type === 'VC' && (
          <Form.Field>
            <span style={{ color: 'black' }}>Volume(cm):</span>
            <input
              value={
                (Math.round(
                  (22 / 7) * (diameter / 2) * (diameter / 2) * height +
                    Number.EPSILON,
                ) *
                  100) /
                100
              }
              onChange={() =>
                setVolume(
                  (Math.round(
                    (22 / 7) * (diameter / 2) * (diameter / 2) * height +
                      Number.EPSILON,
                  ) *
                    100) /
                    100,
                )
              }
              placeholder="..."
            />
          </Form.Field>
        )}
        <Form.Field>
          <span style={{ color: 'black' }}>Latitude:</span>
          <input
            required
            value={latitude}
            onChange={(e) => setLatitude(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>Longitude:</span>
          <input
            required
            value={longitude}
            onChange={(e) => {
              setLongitude(e.target.value)
            }}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>SIM Number</span>
          <input
            type="tel"
            minLength="9"
            maxLength="15"
            pattern="^([+]|00)[0-9]{3,15}"
            required
            value={simNumber}
            onChange={(e) => setSIM(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>IMSI:</span>
          <input
            required
            value={imsi}
            onChange={(e) => setIMSI(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>Raiser:</span>
          <input
            required
            value={raiser}
            onChange={(e) => setRaiser(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>
        <Form.Field>
          <span style={{ color: 'black' }}>Photo:</span>
          <input type="file" onChange={onSelectFile} />
          <br />
          {(selectedFile || photo) && <img src={photo} alt="img" width="400" />}
        </Form.Field>

        <Form.Field>
          <span style={{ color: 'black' }}>Inactivity Threshold (days):</span>
          <input
            required
            type="number"
            step="1"
            value={inactivityTimeout}
            onChange={(e) => setInactivityTimeout(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
        </Form.Field>

        <Form.Field>
          <span style={{ color: 'black' }}>Zone:</span>
          <select onChange={handleZoneChange} value={country}>
            <option selected value="">
              --select zone--
            </option>
            {zones.map((zone) => (
              <option key={zone.id} value={zone.id}>
                {zone.label || zone.name}
              </option>
            ))}
          </select>
        </Form.Field>

        <Form.Field>
          <span style={{ color: 'black' }}>Region:</span>
          <select onChange={handleRegionChange} value={region}>
            <option selected value="">
              --select region--
            </option>
            {regions.map((_region) => (
              <option key={_region.id} value={_region.id}>
                {_region.label || _region.name}
              </option>
            ))}
          </select>
        </Form.Field>

        <Form.Field>
          <span style={{ color: 'black' }}>Site:</span>
          <select value={site} onChange={handleSiteChange}>
            <option selected value="">
              --select site--
            </option>
            {sites.map((_site) => (
              <option
                key={_site.id}
                value={`${_site.id},${_site.label || _site.name}`}
              >
                {_site.label || _site.name}
              </option>
            ))}
          </select>
        </Form.Field>
        <FormField>
          <hr />
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                from="config form"
                type="submit"
                className={styles.button}
                color="red"
              >
                Submit
              </Button>
            </Grid.Column>
          </Grid>
          <br />
        </FormField>
      </Form>
      <DeviceActions onBackClick={() => setViewDevice2(false)} />
    </div>
  )
}

export default DeviceConfigure
